import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseKey);

const BUCKET = 'property-photos';
const MAX_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_WIDTH = 1200;
const QUALITY = 0.8;

// Compress image before upload
const compressImage = (file) => new Promise((resolve) => {
  const img = new Image();
  const canvas = document.createElement('canvas');
  const reader = new FileReader();

  reader.onload = (e) => {
    img.onload = () => {
      let w = img.width, h = img.height;
      if (w > MAX_WIDTH) { h = Math.round(h * MAX_WIDTH / w); w = MAX_WIDTH; }
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', QUALITY);
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
});

// Upload photo to Supabase Storage
export const uploadPhoto = async (file, propertyId) => {
  if (file.size > MAX_SIZE) throw new Error('File too large (max 5MB)');

  const compressed = await compressImage(file);
  const ext = 'jpg';
  const fileName = `${propertyId}/${Date.now()}_${Math.random().toString(36).substr(2, 6)}.${ext}`;

  const { data, error } = await supabase.storage
    .from(BUCKET)
    .upload(fileName, compressed, {
      contentType: 'image/jpeg',
      upsert: false
    });

  if (error) throw error;

  const { data: urlData } = supabase.storage.from(BUCKET).getPublicUrl(data.path);
  return urlData.publicUrl;
};

// Delete photo from Supabase Storage
export const deletePhoto = async (url) => {
  try {
    // Extract path from URL: .../property-photos/p1/123456.jpg → p1/123456.jpg
    const parts = url.split(`/${BUCKET}/`);
    if (parts.length < 2) return;
    const path = parts[1];
    await supabase.storage.from(BUCKET).remove([path]);
  } catch (e) {
    console.error('Delete photo error:', e);
  }
};

export default supabase;
